import React, { memo } from 'react';
import { formatDateToPtBr } from '../../../../../../../utils/date';
import { Button } from 'rsuite';
import styles from './UploadTableAderencia.module.scss';
import { AderenciaTableData } from '../../types';

interface Data {
  data: AderenciaTableData[];
  onClickDownloadFile?: (id: string, name: string) => void;
}

export const UploadTableAderencia = memo(({ data, onClickDownloadFile }: Data) => {
  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th>Data</th>
          <th>Usuário</th>
          <th>Nome do arquivo</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr key={index} className={index === 0 ? styles.normal : styles.opacity}>
            <td>{item.dataEnvio ? formatDateToPtBr(item.dataEnvio) : null}</td>
            <td>{item.usuario}</td>
            <td className={styles.fileName}>
              <Button appearance="link" className={styles['btn-filename']} onClick={() => onClickDownloadFile?.(item?.uploadId, item.nomeArquivo)}>
                {item.nomeArquivo}
              </Button>
              {item?.atual ? <div className={styles.currentFileLabel}>ATUAL</div> : null}
              {item?.pendente ? <div className={styles.pending}>PENDENTE</div> : null}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
});
